import { Header } from "./components/Header";
import { Navigator } from "./components/Navigator";

export default function YourMatches() {
  return (
    <div className="mt-10 min-h-screen flex flex-col p-6 md:px-24 md:py-10 bg-gray-50 dark:bg-gray-900">
      {/* <Header /> */}
      <Navigator />
    </div>
  );
}
